var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductLogoIconSubscriptions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "30px",
    viewBox: "0 0 34 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product-logo-/-Logo-/-Subscriptions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(2.519935, 0.519935)",
    fill: "#0042E4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4800645,0.480064532 C22.212051,0.480064532 28.4800645,6.74807803 28.4800645,14.4800645 C28.4800645,22.212051 22.212051,28.4800645 14.4800645,28.4800645 C6.85256434,28.4800645 0.649737646,22.3803122 0.483486578,14.7927096 L0.480064532,14.4800645 L8.48006453,14.4800645 C8.48006453,17.793773 11.166356,20.4800645 14.4800645,20.4800645 C17.793773,20.4800645 20.4800645,17.793773 20.4800645,14.4800645 C20.4800645,11.2416676 17.9144896,8.60249277 14.7050028,8.484203 L14.4800645,8.48006453 L14.4800645,0.480064532 Z",
    id: "Path",
    transform: "translate(14.480065, 14.480065) rotate(2.000000) translate(-14.480065, -14.480065) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(4.670000, 2.670000)",
    fill: "#FF4E61"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.81655932,
    cy: 4.81655932,
    r: 4.81655932
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLogoIconSubscriptions);
export default __webpack_public_path__ + "static/media/product-logo-icon-subscriptions.c69a3628c43aa8b284881b65cb9e3db9.svg";
export { ForwardRef as ReactComponent };